import { render } from "./ChartStatistic.vue?vue&type=template&id=0e8badb6&ts=true"
import script from "./ChartStatistic.vue?vue&type=script&lang=ts"
export * from "./ChartStatistic.vue?vue&type=script&lang=ts"

import "./ChartStatistic.vue?vue&type=style&index=0&id=0e8badb6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__